import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type ProjectSettingsFieldsFragment = { __typename?: 'Project', isWorkfront?: boolean | null, name: string, description?: string | null, fileCount: number, memberCount?: number | null, mountedStorageStatus?: Types.MountedStorageStatus | null, private: boolean, storage: number, images: { __typename?: 'Images', image256?: string | null, original?: string | null } };

export const ProjectSettingsFields = /*#__PURE__*/ gql`
    fragment ProjectSettingsFields on Project {
  images {
    image256
    original
  }
  isWorkfront
  name
  description
  fileCount
  memberCount
  mountedStorageStatus
  private
  storage
}
    ` as unknown as DocumentNode<ProjectSettingsFieldsFragment, unknown>;

        

        
export const useProjectSettingsFieldsFragment = (
  input: string | Omit<UseFragmentOptions<ProjectSettingsFieldsFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Project' } };
    return input;
  })();

  return useFragment<ProjectSettingsFieldsFragment>({
    fragment: ProjectSettingsFields,
    fragmentName: 'ProjectSettingsFields',
    ...options,
  });
};
  
        